import { store } from "../store/index";
import {
  filterAttendance,
  get,
  createAttendance,
  update,
  removeAttendance,
} from "../store/actions/AttendanceActions";

/**
 * Create Attendance
 */
export const addAttendance = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createAttendance(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Attendance
 */
export const getAttendance = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(get(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Attendance
 */
export const updateAttendance = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(update(objSend, uuid));

  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Attendance
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterAttendance(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Attendance
 */
export const deleteAttendance = async (uuid) => {
  const result = await store.dispatch(removeAttendance([uuid]));
  if (result?.payload) {
    return result.payload;
  }
  return null;
};
